import { EQuizMode } from '@constants';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useProfile } from '../profile';

import { sdk } from '@/services';

const SubscriptionService = sdk.getService('SubscriptionService');

export const useMySubscriptionsWithQuizCourses = (mode: EQuizMode) => {
  const { profile } = useProfile();

  const { isLoading, data, error } = useQuery({
    queryKey: ['subscriptions', mode],
    queryFn: () => SubscriptionService.getMySubscriptionsWithQuizCourses(mode),
    enabled: !!profile
  });

  const filteredSubscriptions = useMemo(() => data?.filter(s => !s.isHidden), [data]);

  const planificableSubscriptions = useMemo(
    () => filteredSubscriptions?.filter(s => s.course.isPlanificable),
    [filteredSubscriptions]
  );

  return {
    error,
    isLoading,
    subscriptions: data,
    filteredSubscriptions,
    planificableSubscriptions
  };
};
